module.exports = __webpack_public_path__ + "static/media/giorgio-armani.e4da8764.jpg";